import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

export default function useProfileHook(profileUser) {
  const {
    interestedAreas,
    interestedSectors,
    assetClassOfInterests,
    givenName,
    email,
    jobFunction,
    surname
  } = profileUser || {}

  const profileData = useSelector(
    (state) => state.profileReducer.profile.profilePictureBase64Encoded
  )
  const [nameProfile, setNameProfile] = useState('')
  const [emailProfile, setEmailProfile] = useState('')
  const [teamProfile, setTeamProfile] = useState('')
  const [selectedJob, setSelectedJob] = useState()
  const [profileAvatar, setProfileAvatar] = useState(profileData)

  const [interestedAreaSelected, setInterestedAreaSelected] = useState([])
  const [interestedSectorSelected, setInterestedSectorSelected] = useState([])
  const [specificAssetsSelected, setSpecificAssetsSelected] = useState([])

  useEffect(() => {
    setNameProfile(`${givenName}, ${surname}`)
    setEmailProfile(email)
    setSelectedJob(jobFunction && { value: jobFunction.id, label: jobFunction.name })
    setProfileAvatar(profileData ? profileData : 'https://dummyimage.com/150x150/D8D8D8/d9ced9')

    setInterestedAreaSelected(
      interestedAreas &&
        interestedAreas.map((item) => {
          return {
            value: item.multiSelectId,
            label: item.value
          }
        })
    )
    setInterestedSectorSelected(
      interestedSectors &&
        interestedSectors.map((item) => {
          return {
            value: item.multiSelectId,
            label: item.value
          }
        })
    )
    setSpecificAssetsSelected(
      assetClassOfInterests &&
        assetClassOfInterests.map((item) => {
          return {
            value: item.multiSelectId,
            label: item.value
          }
        })
    )
  }, [])

  return [
    {
      nameProfile,
      emailProfile,
      teamProfile,
      selectedJob,
      profileAvatar,
      setNameProfile,
      setEmailProfile,
      setTeamProfile,
      setSelectedJob,
      setProfileAvatar,
      interestedAreaSelected,
      interestedSectorSelected,
      specificAssetsSelected,
      setInterestedAreaSelected,
      setInterestedSectorSelected,
      setSpecificAssetsSelected
    }
  ]
}
